var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrongIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 1.83325C4.31671 1.83325 1.33337 4.81659 1.33337 8.49992C1.33337 12.1833 4.31671 15.1666 8.00004 15.1666C11.6834 15.1666 14.6667 12.1833 14.6667 8.49992C14.6667 4.81659 11.6834 1.83325 8.00004 1.83325ZM11.3334 10.8899L10.39 11.8333L8.00004 9.44325L5.61004 11.8333L4.66671 10.8899L7.05671 8.49992L4.66671 6.10992L5.61004 5.16658L8.00004 7.55658L10.39 5.16658L11.3334 6.10992L8.94337 8.49992L11.3334 10.8899Z",
    fill: "#FF2323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrongIcon);
export default __webpack_public_path__ + "static/media/wrong-icon.788b07bf56d949ed996a50fc7ca1a4fb.svg";
export { ForwardRef as ReactComponent };